import React from 'react';
import Image from './Image';
import { bgColorClassname } from '@/utils';
import type { ImageAsset } from '@sanity/types';
import {
  Carousel,
  CarouselContent,
  CarouselDotButton,
  CarouselItem,
} from '@/components/ui/carousel';

interface ImageWithAlt {
  alt?: string;
  image: {
    asset: ImageAsset;
  };
}

interface TestimonialItem {
  stars?: number;
  title: string;
  content?: string;
  includeAuthor: boolean;
  author?: string;
  authorImage?: ImageWithAlt;
}

interface TestimonialProps {
  backgroundColor?: {
    label: string;
    value: string;
  };
  testimonialItems: TestimonialItem[];
}

const Testimonial: React.FC<TestimonialProps> = ({ backgroundColor, testimonialItems }) => {
  return (
    <div className={backgroundColor && bgColorClassname(backgroundColor)}>
      <div className='mx-auto flex max-w-screen-xl flex-col gap-6 px-5 py-8 md:p-[50px]'>
        <div className='font-halyarddisplay flex gap-2'>
          <Carousel
            opts={{
              align: 'start',
            }}
            className='w-full overflow-hidden'
          >
            <CarouselContent className='-ml-4'>
              {testimonialItems &&
                testimonialItems.map((testimonial, index) => (
                  <CarouselItem key={index}>
                    <div
                      key={index}
                      className='mb-5 sm:mb-6'
                    >
                      <div className='text-2xl tracking-[6px]'>
                        {testimonial.stars
                          ? '★'.repeat(testimonial.stars) + '☆'.repeat(5 - testimonial.stars)
                          : '☆'.repeat(5)}
                      </div>
                      <h3 className={`mb-2 mt-3.5 text-2xl font-bold leading-7`}>
                        {testimonial.title}
                      </h3>
                      {testimonial.content && (
                        <p className={`text-lg font-normal`}>{testimonial.content}</p>
                      )}
                      {testimonial.includeAuthor && (
                        <div className='mt-4 flex items-center'>
                          {testimonial.authorImage && (
                            <Image
                              image={testimonial?.authorImage?.image}
                              alt={
                                testimonial?.authorImage?.alt ||
                                `Image of Author ${testimonial?.author}`
                              }
                              className='h-10 w-10 rounded-full'
                              width={40}
                            />
                          )}
                          {testimonial.author && (
                            <p className='ml-3 text-sm font-semibold'>{testimonial.author}</p>
                          )}
                        </div>
                      )}
                    </div>
                  </CarouselItem>
                ))}
            </CarouselContent>
            <CarouselDotButton testimonialCount={testimonialItems.length} />
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
